/** Same identity as vd-server: `createdBy` is JWT `sub` (`token.userId`). */
export function isInvestigationCreator(
  createdBy: string | undefined,
  session: { jwtUser?: { sub?: string } } | null | undefined,
): boolean {
  const sub = session?.jwtUser?.sub;
  return Boolean(createdBy && sub && createdBy === sub);
}
